// import Param from './param';
import Util from './module/libs/util';

import Manager from './manager';
import LocomotiveScroll from './module/libs/locomotive-scroll';
import ScrollMagic from 'scrollmagic';
// import { ScrollMagicPluginIndicator} from "scrollmagic-plugins";


const manager = new Manager();

/* ---------------------------------------------------

  -- load

 --------------------------------------------------- */

window.addEventListener("load", function (e) {
// ・クレーン設計・クレーン製造・メンテナンスのヘッダーとpageTopの専用調整
    if(document.querySelector("body.crane")){
        if(window.innerWidth<1080) {
            document.querySelector("header.isPC").remove()
            document.querySelector("#l-footer-pagetop.isPC").remove()
        }else{
            document.querySelector("header.isNotPC").remove()
            document.querySelector("#l-footer-pagetop.isNotPC").remove()
        }
    }

    manager.init("landing");
    /* ---------------------------------------------------

  -- phone icon href

 --------------------------------------------------- */
    if(window.innerWidth<750){
        document.getElementById("phone").href='tel:0587-32-6255'
    }else{
        if(document.querySelector("body#top")){
            document.getElementById("phone").href='./contact#contactTel'
        }else{
            document.getElementById("phone").href='../contact#contactTel'
        }
    }
});

/* ---------------------------------------------------

-- locomotive scroll

--------------------------------------------------- */
window.addEventListener("load", () => {
    if(document.querySelector("body.crane")){

        const locoScroll = new LocomotiveScroll({
            el: document.querySelector("[data-scroll-container]"),
            smooth: true,
            multiplier: 0.75,
            // getDirection: true,
            mobile: {
                smooth: true,
                inertia: 0.8,
                getDirection: true,
                breakpoint: 0,
            },
            tablet: {
                smooth: true,
                inertia: 0.8,
                getDirection: true,
                breakpoint: 0,
            }
            // scrollFromAnywhere: true,
        });
        // locoScroll.on('scroll', (instance) => {
        //     document.documentElement.setAttribute('data-direction', instance.direction)
        // });
        document.querySelector('.back-to-top').addEventListener('click', ()=>{
            locoScroll.scrollTo(0);
        });
        if(window.innerWidth<1079) {
            document.getElementById("l-header-menu-btn").addEventListener('click', () => {
                if (document.getElementById("l-header-menu-btn").classList.contains("is-close")) {
                    locoScroll.stop();
                } else {
                    locoScroll.start();
                }
            });
        }

    }

});
/* ---------------------------------------------------

-- header scroll

--------------------------------------------------- */
if(window.innerWidth>1079) {
    // console.log("header Scroll")
    const headerController = new ScrollMagic.Controller();
    const sceneH = new ScrollMagic.Scene({
        triggerElement: "#l-load",
        offset: window.innerHeight*0.6,
        // offset: -window.innerHeight*0.1,
    }).on('enter', function () {
        if(!document.querySelector("body.blueTop")){
            const list = document.querySelectorAll("#l-header-nav-link li a");
            for (let i = 0; i < list.length; ++i) {
                list[i].classList.add('blue-text');
            }
            if(document.querySelector("body#top")){
                document.querySelector("#l-header-title .logo img").src="./assets/img/common/c-head_logo-b.svg";
            }else{
                document.querySelector("#l-header-title .logo img").src="../assets/img/common/c-head_logo-b.svg";
            }
        }
        document.querySelector("#l-header__inner").classList.add('active');

        console.log("enter")
    }).on('leave', function () {
        if(!document.querySelector("body.blueTop")) {
            // document.querySelectorAll("#l-header-nav-link li a").classList.remove('active');
            if(!document.querySelector("body.blueTop")){
                const list = document.querySelectorAll("#l-header-nav-link li a");
                for (let i = 0; i < list.length; ++i) {
                    list[i].classList.remove('blue-text');
                }
            }
            if(document.querySelector("body#top")){
                document.querySelector("#l-header-title .logo img").src="./assets/img/common/c-head_logo.svg";
            }else{
                document.querySelector("#l-header-title .logo img").src="../assets/img/common/c-head_logo.svg";
            }
        }
        document.querySelector("#l-header__inner").classList.remove('active');

        console.log("leave")
    }).addTo(headerController);
}


let _pageID = document.getElementsByTagName('body')[0].getAttribute("id");

/* ---------------------------------------------------

  -- event

 --------------------------------------------------- */

window.addEventListener("scroll", function (e) {
    let _y = window.pageYOffset || document.documentElement.scrollTop;
    if(manager) manager.scroll.update(_y,"");
    if(manager) manager.scrolls(e);
});

window.addEventListener("mousemove",function (e) {

    let _x = e.clientX;
    let _y = e.clientY;

    // if(manager) manager.mouse.update(_x,_y);

});

let MOUSE_WHEEL_EVENT = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';

document.addEventListener(MOUSE_WHEEL_EVENT,function(e){

    if(manager) manager.wheel(e);

});

window.addEventListener("touchstart",function (e) {
    if(manager) manager.touchStart(e);
});
window.addEventListener("touchmove",function (e) {

    if(manager) manager.touchmove(e);

}, { passive: false });
window.addEventListener("touchend",function (e) {
    if(manager) manager.touchEnd(e);
});

/* ---------------------------------------------------

  -- resize

 --------------------------------------------------- */
window.addEventListener("resize",function (e) {
    if(manager){
        if(manager.param.displayType=="sp"&&manager.w == window.innerWidth) return;
        manager.resize();
    }
});

/* ---------------------------------------------------

  -- scroll animation when locomotive-scroll

 --------------------------------------------------- */

if(document.querySelector("body.crane")) {
    // ScrollMagicPluginIndicator(ScrollMagic);
    const controller = new ScrollMagic.Controller();
    if(window.innerWidth<750){
        const scene1 = new ScrollMagic.Scene({
            triggerElement: "#p-crane-section__inner01",

            // offset: -100,
            // offset: -window.innerHeight*0.1,
        }).on('enter', function () {
            document.querySelector(".scene1__image").classList.add('active');
            document.querySelector(".p-crane-section__content .scene1__headline").classList.add('active');
            document.querySelector(".p-crane-section__content .scene1__text").classList.add('active');
        }).addTo(controller);
        const scene2 = new ScrollMagic.Scene({
            triggerElement: "#p-crane-section__inner02",
            // offset: -100,
        }).on('enter', function () {
            document.querySelector(".scene2__image").classList.add('active');
            document.querySelector(".p-crane-section__content .scene2__headline").classList.add('active');
            document.querySelector(".p-crane-section__content .scene2__text").classList.add('active');
        }).addTo(controller);
    }else{
        const scene1 = new ScrollMagic.Scene({
            triggerElement: "#p-crane-section__inner01",

            offset: -100,
            // offset: -window.innerHeight*0.1,
        }).on('enter', function () {
            document.querySelector(".scene1__image").classList.add('active');
            document.querySelector(".p-crane-section__content .scene1__headline").classList.add('active');
            document.querySelector(".p-crane-section__content .scene1__text").classList.add('active');
        }).addTo(controller);
        const scene2 = new ScrollMagic.Scene({
            triggerElement: "#p-crane-section__inner02",
            offset: -100,
        }).on('enter', function () {
            document.querySelector(".scene2__image").classList.add('active');
            document.querySelector(".p-crane-section__content .scene2__headline").classList.add('active');
            document.querySelector(".p-crane-section__content .scene2__text").classList.add('active');
        }).addTo(controller);
        const scene3 = new ScrollMagic.Scene({
            triggerElement: "#c-foot-navi",
            offset: -150,
        }).on('enter', function () {
            console.log("enter foor navi")
            const footNaviText = document.querySelectorAll(".c-title-over");
            const footNaviTextInner = document.querySelectorAll(".stroke-text");
            for (let i = 0; i < footNaviText.length; ++i) {
                TweenMax.fromTo(footNaviText[i],1.5,{
                    width: 0,
                },{
                    width: '100%',
                    ease: CustomEase.create("custom", "M0,0,C0.158,0,0.308,0.047,0.344,0.332,0.412,0.88,0.554,0.946,1,1"),
                });
                TweenMax.fromTo(footNaviTextInner[i],1.5,{
                    opacity:1,
                    width: '100%',
                },{
                    opacity:0,
                    // delay: 0.3,
                    delay:0.8,
                    ease: CustomEase.create("custom", "M0,0,C0.158,0,0.308,0.047,0.344,0.332,0.412,0.88,0.554,0.946,1,1"),
                });
            }

        }).addTo(controller);
    }
    if(document.querySelector("body#design") && window.innerWidth<1080) {
        const sectionContent1 = document.querySelector(".p-crane-section01 .p-crane-section__content ");
        const sectionImage1 = document.querySelector(".p-crane-section01 .p-crane-section__image ");
        const sectionContent2 = document.querySelector(".p-crane-section02 .p-crane-section__content ");
        const sectionImage2 = document.querySelector(".p-crane-section02 .p-crane-section__image ");
        document.querySelector(".p-crane-section02").style.marginTop = (sectionContent1.offsetHeight - sectionImage1.offsetHeight * 0.325) + 'px';
        document.querySelector(".p-crane-link__blog1").style.marginTop = (sectionContent2.offsetHeight - sectionImage2.offsetHeight * 0.225) + 'px';
    }
    if(document.querySelector("body#manufacturing") && window.innerWidth<1080) {
        const sectionContent3 = document.querySelector(".p-crane-section03 .p-crane-section__content ");
        const sectionImage3 = document.querySelector(".p-crane-section03 .p-crane-section__image ");
        const sectionContent4 = document.querySelector(".p-crane-section04 .p-crane-section__content ");
        const sectionImage4 = document.querySelector(".p-crane-section04 .p-crane-section__image ");
        document.querySelector(".p-crane-section04").style.marginTop = (sectionContent3.offsetHeight - sectionImage3.offsetHeight * 0.325) + 'px';
        document.querySelector(".p-crane-link__blog2").style.marginTop = (sectionContent4.offsetHeight - sectionImage4.offsetHeight * 0.225) + 'px';
    }
    if(document.querySelector("body#maintenance") && window.innerWidth<1080) {
        const sectionContent5 = document.querySelector(".p-crane-section05 .p-crane-section__content ");
        const sectionImage5 = document.querySelector(".p-crane-section05 .p-crane-section__image ");
        const sectionContent6 = document.querySelector(".p-crane-section06 .p-crane-section__content ");
        const sectionImage6 = document.querySelector(".p-crane-section06 .p-crane-section__image ");
        document.querySelector(".p-crane-section06").style.marginTop = (sectionContent5.offsetHeight - sectionImage5.offsetHeight * 0.325) + 'px';
        document.querySelector(".p-crane-link__blog3").style.marginTop = (sectionContent6.offsetHeight - sectionImage6.offsetHeight * 0.225) + 'px';

    }



}
